import { memo, useState } from 'react'
import { Question } from 'types'
import trashIcon from 'img/dashicons-trash.svg'
import { FeedbackOverlay } from 'lesson-builder/components/feedback-overlay'
import { QuestionContent } from 'lesson-builder/components/question-content'
import { QuestionEditor } from 'lesson-builder/components/question-editor'
import { DeleteConfirmOverlay } from 'lesson-builder/components/delete-confirm-overlay'

/**
 * @module lesson-builder/components/question-container
 * @description One question's card: owns its local editing/feedback/
 * delete-confirm UI state and composes the viewer, editor, and the 2
 * overlays. See
 * docs/BLUEPRINT-2026-10-01-question-slide-decomposition.md.
 */
export const QuestionContainer = memo(({ question, onApprove, onEdit, canDelete, onDelete, canEdit }: { question: Question, onApprove: (approved : boolean) => void, onEdit: (payload: Partial<Question>) => void, canDelete?: boolean, onDelete?: () => void, canEdit?: boolean }) => {
	const [isEditing, setIsEditing] = useState(false)
	const [showFeedback, setShowFeedback] = useState(false)
	const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

	return (
		<div className="question-container">
			<div className="question-container-top-row">
				{question.displayLabel && (
					<div className="question-display-label">{question.displayLabel}</div>
				)}
				{canDelete && onDelete && (
					<button
						className="question-delete-btn"
						onClick={() => setShowDeleteConfirm(true)}
						title="Delete question"
					>
						<img src={trashIcon} alt="Delete" />
					</button>
				)}
			</div>
			{isEditing ? (
				<>
					<QuestionEditor
						question={question}
						setIsEditing={setIsEditing}
						onEdit={onEdit}
						setShowFeedback={setShowFeedback}
					/>
				</>
			) : (
				<>
					<QuestionContent
						question={question}
						setIsEditing={setIsEditing}
						onApprove={onApprove}
						onEdit={onEdit}
						showFeedback={showFeedback}
						setShowFeedback={setShowFeedback}
						canEdit={canEdit}
					/>

				</>
			)}
			{showFeedback && (
				<FeedbackOverlay
					onEdit={onEdit}
					setShowFeedback={setShowFeedback}
					questionId={question.id}
					question={question}
				/>
			)}
			{showDeleteConfirm && (
				<DeleteConfirmOverlay
					onConfirm={() => {
						setShowDeleteConfirm(false)
						onDelete!()
					}}
					onCancel={() => setShowDeleteConfirm(false)}
				/>
			)}
		</div>
	)
})

export default QuestionContainer
